import http from '@/http';

export default {

    list() {
        return http.get('/suppliers');
    },
};



// WEBPACK FOOTER //
// ./src/api/suppliers.js